import PanelNew from '@/containers/SubscriptionFormPageNew/Panel/PanelNew'
import useCustomer from '@/containers/SubscriptionFormPageNew/Components/Customer/useCustomer'
import { useTranslation } from 'react-i18next'
import InteractionItem from './Bones/InteractionItem'

const Interactions = ({ hidden }) => {
  const { t } = useTranslation()
  const { isEkomiRegistered, createEkomiInteraction, whatsappInteraction, isNewsletterRegistered } = useCustomer()

  if (hidden) return null

  return (
    <PanelNew
      title={t('subscriptionForm:header.modal_save_send.interactions_title')}
      id='InteractionsModule'
    >
      <InteractionItem
        active={isEkomiRegistered || !!createEkomiInteraction}
        label={t('subscriptionForm:header.modal_save_send.interaction_ekomi')}
      />
      <InteractionItem
        active={!!whatsappInteraction}
        label={t('subscriptionForm:header.modal_save_send.interaction_whatsapp')}
      />
      <InteractionItem
        active={!!isNewsletterRegistered}
        label={t('subscriptionForm:header.modal_save_send.interaction_newsletter')}
      />
    </PanelNew>
  )
}

export default Interactions
